require('./avatarCreator.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { FormattedText } = require('core/i18n').i18n;
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @ components
const makeAvatar = require("vendor/avatarCreator/svgavatars.core.js");

const { OKButton } = require('components/commons/OKButton/OKButton');

//@ constants
import AvatarEditorTranslations from 'constants/avatarEditorTranslations.js';

class AvatarCreator extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCloseAvatar = this.handleCloseAvatar.bind(this);

        this.state = {
            isShown: false
        }
    }

    handleClick() {
        const visible = !this.state.isShown;
        const translations = AvatarEditorTranslations();
        if (!visible){
            const colorPicker = document.getElementsByClassName('sp-container');
            // remove the colorpicker palette when closing avatar modal in case it was opened
            colorPicker.length > 0 && colorPicker[0].remove();
        }
        this.setState({
            isShown: visible
        });
        if (visible) {
            window.setTimeout(() => makeAvatar(this.handleClick, this.handleSave, translations), 0);
        }
    }

    handleCloseAvatar()  {
        this.setState({
            isShown: false
        });
    }

    handleSave(imageData) {
        this.props.onSave(imageData);
    }

    renderCreator() {
        // Setting id="svgAvatars" is required by the library and cannot be changed
        return (
            <div className="avatarcreator-overlay">
                <div className="avatarcreator-overlay__workarea" id="svgAvatars">
                    <h2 className="avatarcreator-overlay__title text-left">
                        <FormattedText value="avatarPicker-createImage" />
                    </h2>
                    <div className="avatarcreator-overlay__close-button">
                        <button
                            onClick={this.handleCloseAvatar}
                            className="avatarcreator-overlay__close-button--icon icon-cerrar"
                        ></button>
                    </div>
                </div>
            </div>
        );
    }

    renderOpenButton() {
        return (
            <OKButton modifier="secondary" leftIcon="icon-beneficiario" size="regular" block={true} onClick={this.handleClick}>
                <FormattedText value="avatarPicker-createImage" />
            </OKButton>
        );
    }

    render() {
        return this.state.isShown ? this.renderCreator() : this.renderOpenButton();
    }
}

AvatarCreator.propTypes = {
    onSave : PropTypes.func.isRequired
};

module.exports = AvatarCreator;
